import { PFDialog } from './PFDialog';
import { Confirm } from '../../Utilities/Confirm';
import { FunctionComponent } from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { ConfirmInfo } from './ConfirmDialog';
import { useTranslation } from '../../Locales/i18n/localizationService';

interface IProps {
    ConfirmInfo?: ConfirmInfo;
}

export const SharedConfirmDialog: FunctionComponent<IProps> = props => {
	const { t } = useTranslation();
	//TODO Make defaultConfirmInfo globally available when localization has been remade
    const defaultConfirmInfo: ConfirmInfo = {
		show: false,
        title: '',
        subtext: '',
        confirmAction: () => {},
        dismissAction: () => {},
        okButtonText: t("Common.Ok"),
        cancelButtonText: t("Common.Cancel"),
        hideCancelButton: true,
    };
	
	const [confirmInfo, setConfirmInfo] = useState<ConfirmInfo>(props.ConfirmInfo ? props.ConfirmInfo : defaultConfirmInfo);
	
	useEffect(() => {
		Confirm.Instance.Register((info: ConfirmInfo) => setConfirmInfo(info));
	}, []);

    return (
        <PFDialog
            title={confirmInfo.title}
            subText={confirmInfo.subtext}
            showDialog={confirmInfo.show}
            maxWidth={500}
            callback={() => {
                confirmInfo.confirmAction();
                setConfirmInfo(defaultConfirmInfo);
            }}
            dismissCallback={() => {
                if (confirmInfo.dismissAction) confirmInfo.dismissAction();
                setConfirmInfo(defaultConfirmInfo);
            }}
            buttonText={confirmInfo.okButtonText}
            cancelButtonText={confirmInfo.cancelButtonText}
            noCancelButton={confirmInfo.hideCancelButton}
        />
    );
};
